export const RETRIEVE_PROVIDER = 'RETRIEVE_PROVIDER'
export const RETRIEVE_PROVIDER_PENDING = `${RETRIEVE_PROVIDER}_PENDING`
export const RETRIEVE_PROVIDER_FULFILLED = `${RETRIEVE_PROVIDER}_FULFILLED`
export const RETRIEVE_PROVIDER_REJECTED = `${RETRIEVE_PROVIDER}_REJECTED`

export const CREATE_NEW_LEAD_PROVIDER = 'CREATE_NEW_LEAD_PROVIDER'
export const CREATE_NEW_LEAD_PROVIDER_PENDING = `${CREATE_NEW_LEAD_PROVIDER}_PENDING`
export const CREATE_NEW_LEAD_PROVIDER_FULFILLED = `${CREATE_NEW_LEAD_PROVIDER}_FULFILLED`
export const CREATE_NEW_LEAD_PROVIDER_REJECTED = `${CREATE_NEW_LEAD_PROVIDER}_REJECTED`

export const UPDATE_PROVIDER = 'UPDATE_PROVIDER'
export const UPDATE_PROVIDER_PENDING = `${UPDATE_PROVIDER}_PENDING`
export const UPDATE_PROVIDER_FULFILLED = `${UPDATE_PROVIDER}_FULFILLED`
export const UPDATE_PROVIDER_REJECTED = `${UPDATE_PROVIDER}_REJECTED`

export const LIST_PROVIDER = 'LIST_PROVIDER'
export const LIST_PROVIDER_PENDING = `${LIST_PROVIDER}_PENDING`
export const LIST_PROVIDER_FULFILLED = `${LIST_PROVIDER}_FULFILLED`
export const LIST_PROVIDER_REJECTED = `${LIST_PROVIDER}_REJECTED`

export const ACCEPTED_PROVIDER = 'ACCEPTED_PROVIDER'
export const ACCEPTED_PROVIDER_PENDING = `${ACCEPTED_PROVIDER}_PENDING`
export const ACCEPTED_PROVIDER_FULFILLED = `${ACCEPTED_PROVIDER}_FULFILLED`
export const ACCEPTED_PROVIDER_REJECTED = `${ACCEPTED_PROVIDER}_REJECTED`

export const STAND_BY_PROVIDER = 'STAND_BY_PROVIDER'
export const STAND_BY_PROVIDER_PENDING = `${STAND_BY_PROVIDER}_PENDING`
export const STAND_BY_PROVIDER_FULFILLED = `${STAND_BY_PROVIDER}_FULFILLED`
export const STAND_BY_PROVIDER_REJECTED = `${STAND_BY_PROVIDER}_REJECTED`

export const REFUSAL_PROVIDER = 'REFUSAL_PROVIDER'
export const REFUSAL_PROVIDER_PENDING = `${REFUSAL_PROVIDER}_PENDING`
export const REFUSAL_PROVIDER_FULFILLED = `${REFUSAL_PROVIDER}_FULFILLED`
export const REFUSAL_PROVIDER_REJECTED = `${REFUSAL_PROVIDER}_REJECTED`

export const MEETING_PROVIDER = 'MEETING_PROVIDER'
export const MEETING_PROVIDER_PENDING = `${MEETING_PROVIDER}_PENDING`
export const MEETING_PROVIDER_FULFILLED = `${MEETING_PROVIDER}_FULFILLED`
export const MEETING_PROVIDER_REJECTED = `${MEETING_PROVIDER}_REJECTED`

export const APPROVED_PROVIDER = 'APPROVED_PROVIDER'
export const APPROVED_PROVIDER_PENDING = `${APPROVED_PROVIDER}_PENDING`
export const APPROVED_PROVIDER_FULFILLED = `${APPROVED_PROVIDER}_FULFILLED`
export const APPROVED_PROVIDER_REJECTED = `${APPROVED_PROVIDER}_REJECTED`

export const VALID_DOCUMENT = 'VALID_DOCUMENT'
export const VALID_DOCUMENT_PENDING = `${VALID_DOCUMENT}_PENDING`
export const VALID_DOCUMENT_FULFILLED = `${VALID_DOCUMENT}_FULFILLED`
export const VALID_DOCUMENT_REJECTED = `${VALID_DOCUMENT}_REJECTED`



// WEBPACK FOOTER //
// ./src/provider/ProviderConstants.js